/**
 * @Copyright 2014-2017 DataVoke, Inc. All rights reserved.
 */
'use strict';

import './support/zebra';
import ko from 'knockout';
import app from './appContext';

import clientTemplate from 'raw-loader!./clientTemplate.html';
import './clientTemplate.css';
import * as dvtypes from './utils/dvtypes';
import * as tools from './utils/tools';
import * as validate from './utils/validation';
import device from '../../client-web/js/device';
import dummyComp from './dummyComponent';

import zebraJson from './support/zebrajson';
import packageJson from '../../package.json';
import './support/canvg';

window.app = app; // needed in zebra.js (FIXME which it probably shouldn't)
app.dv = app.dv || {};

import services from './services/services';
import * as entities from './entities/entities';
import {cache} from './cache/cache';
import helpers from './helpers/helpers';
import uiImageMgr from './controls/uiImageMgr';
import dvLogin from './controls/login/dvlogin';
import elementStyle from './models/dvElementStyle';
import dvPinpoint from './controls/pinpointsearch/dvpinpoint';
import dvUserEntry from './controls/userentry/dvuserentry';
import viewToPDF from './reporting/ViewToPDF';
import API from './api/api';
window.api = new API();
window.featureToggles = {};

let parseQueryParameters = () => {
    let pairs = decodeURI(document.location.search).substring(1).split('&');

    let temp = {};
    for(let pair of pairs) {
        pair = pair.split('=');
        temp[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }

    return temp;
};
let getAuthType = (params) => {
    let authType = Object.keys(params)
    // map to RegExp#exec
        .map(arg => /(.+)_token/.exec(arg))
        // filter out any that didn't match
        .filter(arg => !!arg)
        // take the first one that matched
        [0];
    // Extract the text before '_token' from the RegExp#exec response
    authType = authType && authType[1];
    return authType;
};

function componentViewModel(params) {
    var c = {};
    app.dv = c;
    app.dv.entities = entities;
    app.dv.services = services;
    app.dv.cache = cache;
    app.dv.helpers = helpers;
    app.dv.reporting = {
        ViewToPDF: viewToPDF(),
        globalSettings: {
            // When specified, null field values will be replaced with the string here...EK
            showBlankFieldsAs: '',
            // When this is true and a report has no records, a dummy record will be created with values populated with showBlankFieldsAs text...EK
            createDummyRecordWhenEmpty: false,
            // Define a way to extend reporting with event hooks.  They are defined here using the report UID key and an object defining the functions...EK
            eventHandlers: new tools.dictionary()
        }
    };
    app.dv.models = {
        elementStyle,
        font: elementStyle.dvFont
    };
    app.dv.forms = {
        controls: {
            minWidth: 45,
            minHeight: 45,
        }
    };
    //TODO: Remove once expressions are taken back out of the DB
    app.dv.tools = tools;
    app.dv.tools.validate = validate;

    // Empty object to store the different window classes
    app.windows = {};

    //Create theme for the Coactive Platform...
    c.productName = params.productName;
    c.loaderPanelHtml = ko.observable('');
    c.isLoading = ko.observable(true);

    //#region "No service connection" handlers
    c.isNoServiceConnection = ko.observable(!navigator.onLine);
    c.reconnect = function() {
        if (app.dv.cache.session.configEntity == null) {
            // The initial socket connection failed which means nothing was loaded, we need to reload the browser instead
            app.dv.clientExit();
        }
        else if (app.connection.state() === app.dv.types.SocketStates.CONNECTING) {
            // Reset the exponential backoff reconnecting loop
            app.connection._resetReconnectTimer();
        }
        else {
            // Start the exponential backoff reconnecting loop
            app.connection._reconnect();
        }
    };

    window.addEventListener("online", function (e) {
        console.info('Browser gained network connection at', (new Date()).toLocaleTimeString());
        c.reconnect();
    });

    window.addEventListener("offline", function (e) {
        console.info('Browser lost network connection at', (new Date()).toLocaleTimeString());
        // Allow the session to determine how to handle the event if the user has logged in
        if (app.dv.cache.session != null) {
            app.dv.cache.session.handleConnectionLost();
        }
        else {
            app.dv.isNoServiceConnection(true);
        }
        if (app.connection.state() !== app.dv.types.SocketStates.CONNECTING) {
            // Start the exponential backoff reconnecting loop
            app.connection._reconnect();
        }
    });
    //#endregion

    //#region "mismatched service version" handler
    c.mismatchedVersion = ko.observable('');
    c.mismatchCancel = function() {
        c.mismatchedVersion('');
    };
    //#endregion

    c.appSpace = {
        id: Math.floor(Math.random() * 100000),
    };

    c.dvPackage = packageJson;
    console.info('version:', packageJson.version);

    // if we have params and a app.dummyComp, then we have ko.
    app.dummyComp = dummyComp;

    c.modelLogin = ko.observable(new dummyComp.model());
    c.modelUserEntry = ko.observable(new dummyComp.model());
    c.modelPinpoint = ko.observable(new dummyComp.model());

    //c.uiImageMgr = uiImageMgr;
    c.imageMgr = uiImageMgr;

    c.compLogin = dvLogin;
    //register the exception alert component
    c.compLogin.register();
    //update the model binding to the one for the component.
    c.modelLogin(new c.compLogin.model());

    c.compPinpoint = dvPinpoint;
    c.compPinpoint.register();

    var runningPinpoint = false;
    app.dv.showPinpoint = function(keepOpen) {
        if(runningPinpoint) {
            return;
        }
        runningPinpoint = true;
        app.dv.modelPinpoint(new c.compPinpoint.model());
        app.dv.modelPinpoint().init(function(){
            runningPinpoint = false;
        });
        app.dv.modelPinpoint().show(keepOpen);
    };

    c.compUserEntry = dvUserEntry;
    //register the exception alert component.
    c.compUserEntry.register();

    var runningUserEntry = false;
    app.dv.showUserEntry = function (dvGridValue, titleText, defaultValue, callback, list, index) {
        if (runningUserEntry) {
            return;
        }
        runningUserEntry = true;
        app.dv.modelUserEntry(new c.compUserEntry.model());
        app.dv.modelUserEntry().init(dvGridValue, titleText, defaultValue, (value) => {
            app.dv.modelUserEntry().dispose();
            app.dv.modelUserEntry(new app.dummyComp.model());
            if (callback != null) {
                callback(value);
            }
            runningUserEntry = false;
        }, list, index);
        app.dv.modelUserEntry().show();
    };

    /**
     * Function to execute any startup JavaScript configured for this environment.
     * This will handle synchronous or asynchronous startup scripts.
     * @returns {Promise<*>}
     */
    c.runStartupJS = async () => {
        if (api.environment.queryStringParams.safemode != null) {
            return;
        }

        const startupJS = app.dv.cache.session.config.CustomSite.StartupJS;

        // ensure we have something to execute
        if (startupJS && startupJS !== '' && typeof startupJS === "string") {
            // create a new Function based off the script and immediately execute it.
            return new Function(startupJS)();
        }
    };


    c.clientExit = function () {
        //Clean up after ourselves... Other client versions will want to use these registrations.
        let name = c.modelLogin.componentName;
        if (ko.components.isRegistered(name)) {
            c.modelLogin().hide();
            c.modelLogin(app.dv.dummyComp);
            ko.components.unregister(name);
        }
        name = c.modelUserEntry.componentName;
        if (ko.components.isRegistered(name)) {
            c.modelUserEntry().hide();
            c.modelUserEntry(app.dv.dummyComp);
            ko.components.unregister(name);
        }

        name = c.modelPinpoint.componentName;
        if (ko.components.isRegistered(name)) {
            c.modelPinpoint().hide();
            c.modelPinpoint(app.dv.dummyComp);
            ko.components.unregister(name);
        }

        // go through all MVCs and unload them.
        c.cache.unload();

        // refresh the browser. By doing this, all KO and RequireJS components will
        // be unloaded and reloaded during the refresh...WR
        document.location.reload();
    };

    // device or environment specific code
    app.device = device;

    app.dv.types = dvtypes;

    let zebraReady = function() {
        return new Promise((resolve) => {
            zebra.ready(() => {
                resolve();
            });
        });
    };

    let start = async function () {
        try {
            if (process.env.NODE_ENV === 'development') {
                await import('../local.config');
            }
        }
        catch (e) {
            console.error("developer doesn't have a local.config.js file");
        }

        if (process.env.CLIENT_SOCKET_URL) {
            // Someone has set the socket env var manually (IE to run against a remote service)
            // or a client (most likely mobile) is being built to point to a remote API service
            app.config.socketUrl = process.env.CLIENT_SOCKET_URL;
        }

        let socketUrl = app.config.socketUrl || (window.location.protocol === 'https:' ? 'wss://' : 'ws://') + window.location.host + '/clientSocket';

        try {
            await app.connection.connect(socketUrl, 'echo-protocol');
        }
        catch (e) {
            c.isNoServiceConnection(true);
        }

        await app.dv.cache.preLoad();

        // either pull the HTML from the settings or use the default.
        let preLoginHTML = '<div class="load-container"><div class="load-message"><div class="load-message-image"></div></div></div>';

        if (app.dv.cache.session.configEntity.ConfigValue.CustomSite != null
            && app.dv.cache.session.configEntity.ConfigValue.CustomSite.LoadingSplashHTML != null
            && !window.location.pathname.startsWith('/admin')) {
            preLoginHTML = app.dv.cache.session.configEntity.ConfigValue.CustomSite.LoadingSplashHTML;
        }

        if (preLoginHTML != null && preLoginHTML !== '') {
            c.loaderPanelHtml(preLoginHTML);
        }

        app.dv.actionLibrary = await import('./cache/actionLibrary');

        //Now that the config is pulled, into the cache, load the build api...AM
        api.build.updateFromConfig();

        app.dv.mvc = await import('./cache/mvc');

        cache.loadSnapshot();
    };

    start().then(async () => {
        if (app.apiContext) {
            // load those items that are required for API use.
        }
        else {
            // since we are not in an API context, update the tab or browser title by updating the DOM element.
            if (app.dv.cache.session.configEntity.ConfigValue.CustomSite
                && app.dv.cache.session.configEntity.ConfigValue.CustomSite.Title
                && !window.location.pathname.startsWith('/admin')) {
                document.title = app.dv.cache.session.configEntity.ConfigValue.CustomSite.Title;
            }
            else {
                document.title = c.envName;
            }

            const zebraJSON = zebraJson;
            let uiTheme;

            if (app.dv.cache.session.configEntity.ConfigValue.SavedThemes == null || app.dv.cache.session.configEntity.ConfigValue.SavedThemes.length === 0) {
                //TODO: After the conversion, this should not be necessary...BC

                app.dv.cache.session.configEntity.ConfigValue.SavedThemes = [];

                uiTheme = {};

                uiTheme.Name = "Classic Blue";
                uiTheme.IsCurrent = true;

                uiTheme.Primary1 = zebraJson.palette.Primary1 = "#6C939F";
                uiTheme.Primary2 = zebraJson.palette.Primary2 = "#457585";
                uiTheme.Primary = zebraJson.palette.Primary = "#26596A";
                uiTheme.Primary3 = zebraJson.palette.Primary3 = "#104050";
                uiTheme.Primary4 = zebraJson.palette.Primary4 = "#022835";

                uiTheme.Secondary1 = zebraJson.palette.Secondary1 = "#E4E4E4";
                uiTheme.Secondary2 = zebraJson.palette.Secondary2 = "#CECECE";
                uiTheme.Secondary = zebraJson.palette.Secondary = "#AAAAAA";
                uiTheme.Secondary3 = zebraJson.palette.Secondary3 = "#A1A1A1";
                uiTheme.Secondary4 = zebraJson.palette.Secondary4 = "#808080";

                uiTheme.PrimaryFormFontColor = zebraJson.palette.FontColor = "#000000";
                uiTheme.SecondaryFormFontColor = zebraJson.palette.SecondaryFontColor = "#444444";
                uiTheme.PrimaryHeaderFontColor = zebraJson.palette.PrimaryHeaderFontColor = "#FFFFFF";
                uiTheme.SecondaryHeaderFontColor = zebraJson.palette.SecondaryHeaderFontColor = "#000000";

                uiTheme.dateMarker = zebraJson.palette.DateMarker = "rgba(228, 228, 228, 0.5";
                uiTheme.DefaultStyle = null;
                app.dv.cache.session.configEntity.ConfigValue.SavedThemes.push(uiTheme);
            }
            else {
                uiTheme = app.dv.cache.session.configEntity.ConfigValue.SavedThemes.find(t => t.IsCurrent);

                if (uiTheme == null) {
                    uiTheme = app.dv.cache.session.configEntity.ConfigValue.SavedThemes[ 0 ];
                    uiTheme.IsCurrent = true;
                }

                zebraJSON.palette.Name = uiTheme.Name;
                zebraJSON.palette.Primary = uiTheme.Primary;
                zebraJSON.palette.Primary1 = uiTheme.Primary1;
                zebraJSON.palette.Primary2 = uiTheme.Primary2;
                zebraJSON.palette.Primary3 = uiTheme.Primary3;
                zebraJSON.palette.Primary4 = uiTheme.Primary4;

                zebraJSON.palette.Secondary = uiTheme.Secondary;
                zebraJSON.palette.Secondary4 = uiTheme.Secondary4;
                zebraJSON.palette.Secondary3 = uiTheme.Secondary3;
                zebraJSON.palette.Secondary2 = uiTheme.Secondary2;
                zebraJSON.palette.Secondary1 = uiTheme.Secondary1;

                zebraJSON.palette.fontColor = uiTheme.PrimaryFormFontColor;
                zebraJSON.palette.SecondaryFontColor = uiTheme.SecondaryFormFontColor;
                zebraJSON.palette.PrimaryHeaderFontColor = uiTheme.PrimaryHeaderFontColor;
                zebraJSON.palette.SecondaryHeaderFontColor = uiTheme.SecondaryHeaderFontColor;

                zebraJSON.palette.dateMarker = tools.hexToRgbaString(uiTheme.Secondary, .5);
            }

            // apply theming to the Zebra API objects.
            zebra()["zebra.json"] = zebraJSON;

            // load the DV zebra extensions
            await zebraReady();

            // Call the function to register for and handle screen resolutions changes
            app.browser.watchScreenResolution();

            const dvZebra = await import('./controls/dvZebra');

            //apply the palette colors
            dvZebra.dvZebraJSON.palette.Name = uiTheme.Name;
            dvZebra.dvZebraJSON.palette.Primary = uiTheme.Primary;
            dvZebra.dvZebraJSON.palette.Primary1 = uiTheme.Primary1;
            dvZebra.dvZebraJSON.palette.Primary2 = uiTheme.Primary2;
            dvZebra.dvZebraJSON.palette.Primary3 = uiTheme.Primary3;
            dvZebra.dvZebraJSON.palette.Primary4 = uiTheme.Primary4;

            dvZebra.dvZebraJSON.palette.Secondary = uiTheme.Secondary;
            dvZebra.dvZebraJSON.palette.Secondary4 = uiTheme.Secondary4;
            dvZebra.dvZebraJSON.palette.Secondary3 = uiTheme.Secondary3;
            dvZebra.dvZebraJSON.palette.Secondary2 = uiTheme.Secondary2;
            dvZebra.dvZebraJSON.palette.Secondary1 = uiTheme.Secondary1;

            dvZebra.dvZebraJSON.palette.FontColor = uiTheme.PrimaryFormFontColor;
            dvZebra.dvZebraJSON.palette.SecondaryFontColor = uiTheme.SecondaryFormFontColor;
            dvZebra.dvZebraJSON.palette.PrimaryHeaderFontColor = uiTheme.PrimaryHeaderFontColor;
            dvZebra.dvZebraJSON.palette.SecondaryHeaderFontColor = uiTheme.SecondaryHeaderFontColor;

            dvZebra.dvZebraJSON.palette.dateMarker = tools.hexToRgbaString(uiTheme.Secondary, .5);
            // this should load the JSON content into Zebra API for this version of the client.

            new zebra.util.Bag(zebra.ui).load(dvZebra.dvZebraJSON);

            // after Zebra and our local extensions have loaded, init style helper settings that rely on Zebra.
            zebra.util.styleHelpers.init();

            // ...and we need to load the gridController objects that rely on Zebra.
            app.dv.mvc.gridController.loadNonAPI();

            const themeController = await import('./themes/ThemeController');

            app.themeController = new themeController.ThemeController();
            app.theme = app.themeController.current;

            //Load and register all core widgets...
            app.dv.widgets = await  import('./widgets');

            //Load the core widgets to cache.eg
            app.dv.cache.loadExtensionCache(app.dv.widgets.coreWidgets);

            //hotkey bindings
            const hotKeys = await import('./utils/hotkeys');

            hotKeys.registerHotKeys(document);
            //already handling the hotkeys in the canvas keydown event, this double fires the event if we jquery bind it...TD
            //hotkeys.registerHotKeys(zebra.ui.$clipboard);
            zebra.customKeyHandler = hotKeys.handleHotKey;
            app.hotkeys = hotKeys;

            // JSHint package, used to assist in hints for JS language and error checking.
            api.utils.loadResource("https://cdnjs.cloudflare.com/ajax/libs/jshint/2.9.5/jshint.js", 'javascript');

            // Import all base controls into the app space
            app.baseControls = await import('./base-controls');

            // import form controls into the app space
            app.controls = await import('./controls');
            app.WindowManager = app.controls.WindowManager;
            app.windows.ViewWindow = app.controls.ViewWindow;
            app.windows.PromptMessageWindow = app.controls.PromptMessageWindow;
            app.windows.PromptInputWindow = app.controls.PromptInputWindow;
            app.windows.DatePicker = app.controls.DatePicker;
            app.windows.FieldHistory = app.controls.fieldHistory;
            app.windows.WINDOW_TYPES = app.baseControls.WINDOW_TYPES;
            app.windows.WINDOW_STATES = app.baseControls.WINDOW_STATES;

            // Import the designer window into the window appspace
            // TODO this needs to be done in designer workspace instead...
            const designerWindow = await import('./designer/controls/DesignerWindow');

            app.windows.DesignerWindow = designerWindow.DesignerWindow;

            // load the chart module.
            const zebraChart = await import('./support/zebraChartjs');

            //#region Prevent back button navigation
            if (app.dv.cache.session.configEntity.ConfigValue.preventBrowserBack) {

                // Handle the onpopstate event (fired when the user "presses back" in any way).
                window.onpopstate = function(event) {
                    // Insert a history record above the current, so any future back operations result in staying in the application.
                    history.pushState({}, "", window.location.href);
                };

                // Insert a history event, so a "Back" operation doesn't leave the application.
                history.pushState({}, "", window.location.href);
            }
            //#endregion

            let publicFormName = window.location.pathname.startsWith('/pub/') && decodeURIComponent(window.location.pathname.substr(window.location.pathname.indexOf('/pub/') + 5)),
                privateFormName = window.location.pathname.startsWith('/form/') && decodeURIComponent(window.location.pathname.substr(window.location.pathname.indexOf('/form/') + 6)),

                /**
                 * This gets replaced with the value in the config.xml for cordova at build time
                 * @type {string}
                 */
                cordovaFormAccess = process.env.CLIENT_FORM_ACCESS_PATH;

            if (cordovaFormAccess) {
                if (cordovaFormAccess.startsWith('pub/')) {
                    publicFormName = cordovaFormAccess.substr(4);
                }
                else if (cordovaFormAccess.startsWith('form/')) {
                    privateFormName = cordovaFormAccess.substr(5);
                }
            }

            let queryParams = parseQueryParameters();
            let authType = getAuthType(queryParams);
            let customLoginForm = app.dv.cache.session.config.CustomLoginViewID;

            /**
             * Create the user/designer workspace to allow forms to show
             * @param {boolean} [loadStartupView = true]
             * @param {boolean} [showWorkspace = true]
             * @param {boolean} [ignorePasswordReset = false]
             * @returns {Promise<void>}
             */
            let createWorkspace = async (loadStartupView = true, showWorkspace = true, ignorePasswordReset = false) => {
                let element = document.getElementById('dvInstance');
                app.dv.userWorkspace = new app.controls.UserWorkspace('user');

                if (!showWorkspace) {
                    app.dv.userWorkspace.baseElement.style.visibility = "hidden";
                }

                if (app.dv.cache.session.isDesigner && app.designer != null && api.isMobileDevice() === false) {
                    app.designer.workspace = new window.api.designer.controls.DesignerWorkspace('designer');
                    if (!showWorkspace) {
                        app.designer.workspace.baseElement.style.visibility = "hidden";
                    }

                    const designerWorkspace = await app.designer.workspace.init(element);
                    // either dock will change the size of the available user space.
                    designerWorkspace.leftDockHover = false;
                    designerWorkspace.rightDockHover = false;
                    await designerWorkspace.attachDesigner(element);

                    let dockPos = app.baseControls.BaseWorkspaceDocker.DOCKER_POSITIONS;
                    let toolboxRail = new window.api.designer.controls.ToolboxRail();
                    designerWorkspace.toolboxRail = toolboxRail;
                    designerWorkspace.toolboxRail.docker = designerWorkspace._leftDocker;
                    designerWorkspace.addRail(toolboxRail);

                    let settingsRail = new window.api.designer.controls.Rail('Settings', dockPos.RIGHT);
                    designerWorkspace.settingsRail = settingsRail;
                    designerWorkspace.settingsRail.docker = designerWorkspace._rightDocker;
                    designerWorkspace.addRail(settingsRail);
                    settingsRail.setVisible(false);

                    //Create Docker reference accessible for ease of use.
                    app.designer.dockers = {};
                    app.designer.dockers.topDocker = designerWorkspace._topDocker;
                    app.designer.dockers.bottomDocker = designerWorkspace._bottomDocker;
                    app.designer.dockers.rightDocker = designerWorkspace._rightDocker;
                    app.designer.dockers.leftDocker = designerWorkspace._leftDocker;

                    //Create Rails reference object for ease of use...eg
                    app.designer.rails = {};
                    app.designer.rails.settingsRail = settingsRail;
                    app.designer.rails.toolboxRail = toolboxRail;
                    //app.designer.rails.layoutRail = layoutRail;


                    //Set the designer workspace
                    app.designer.workspace = designerWorkspace;

                    //set the rail controller ...eg
                    app.designer.railControl = new app.designer.RailControl(toolboxRail, settingsRail);

                    await app.designer.workspace.setContentWorkspace(app.dv.userWorkspace);

                    // now process any startup JavaScript
                    await c.runStartupJS();

                    if (loadStartupView) {
                        finishLoading(ignorePasswordReset);
                    }
                }
                else {
                    await app.dv.userWorkspace.init(element);

                    // now process any startup JavaScript
                    await c.runStartupJS();

                    if (loadStartupView) {
                        finishLoading(ignorePasswordReset);
                    }
                }
            };

            /**
             * Finish loading after creating the workspace (createWorkspace() calls this function!)
             * @param {boolean} [ignorePasswordReset = false]
             * @returns {Promise<void>}
             */
            let finishLoading = (ignorePasswordReset = false) => {
                if(window.location.pathname === '/admin' || api.environment.queryStringParams.adminAccess) {
                    // We are loading from an admin request, do not load the startup view...AM
                    return loginCompleted();
                }

                //Execute the startup view (if exists), once complete, continue processing the login.
                setTimeout(() => {
                    //NOTE:  This must be done in a setTimeout so that the UI can create the modelWorkspace above as a dom element..EK
                    app.dv.cache.session.startupView(() => {
                        if (app.dv.cache.session.currentUser.User.Definition.ForcePwdChange && !ignorePasswordReset) {
                            app.dv.modelLogin().show(app.dv.compLogin.types.forcePasswordReset, (success) => {
                                if (success) {
                                    app.dv.actionLibrary.executeShowMessage(null, null, null, "Password has been changed successfully!", null, null, false, null);
                                    loginCompleted();
                                }
                                else {
                                    app.dv.actionLibrary.executeShowMessage(null, app.dv.clientExit, null, "You must change your password before you can login. Exiting client.", null, null, false, null);
                                }
                            });
                        }
                        else {
                            loginCompleted();
                        }
                    });
                });
            };

            /**
             * Process the login using the default login form.
             */
            let doLogin = () => {
                c.isLoading(false);

                //force a login action.
                app.dv.modelLogin().show(app.dv.compLogin.types.firstLogin, (isAuthenticated, msg) => {
                    if (isAuthenticated === true) {
                        createWorkspace();
                    }
                    else {
                        app.dv.actionLibrary.executeShowMessage(null, () => {
                            app.dv.clientExit();
                        }, null, (msg != null ? msg : "Exiting client."), null, null, false, null);
                    }
                });
            };

            /**
             * Process when the login is completed.
             * @returns {Promise<void>}
             */
            let loginCompleted = async () => {
                //Check if we were attempting to access a private form hyperlink
                if (privateFormName || api.environment.queryStringParams.privateFormName) {
                    const args = {AccessName: privateFormName || api.environment.queryStringParams.privateFormName};

                    try {
                        const res = await services.call(services.endpoints.getPrivateFormID, args);

                        if (res && res.ViewID) {
                            // We received a valid private form, attempt to open it...AM
                            app.dv.actionLibrary.inlineExe(null, app.dv.actionLibrary.actionStores.dvCore.OpenView, {
                                viewId: res.ViewID,
                                mode: res.openMode != null ? res.openMode : app.dv.types.OPEN_MODES.NORMAL,
                                supressVisiblity: false
                            }, (result) => {
                                if (result && !result.success || (!result.continueExecution && result.actionMessage !== "")) {
                                    // if there is a problem, show the returned message.
                                    let message = (typeof result.actionMessage === "object") ? result.actionMessage.message : result.actionMessage;
                                    app.dv.actionLibrary.executeShowMessage(null, null, null, message, true, null, false, app.dv.types.MessageType.Error, "Error during load");
                                }

                                //Hide the loading message...eg
                                app.dv.modelLogin().hide();
                            });
                        }
                        else {
                            // There was an error attempting to open the private form, display the error...AM
                            app.dv.actionLibrary.executeShowMessage(null, null, null, 'Form ID not found', true, null, false, null);

                            //Hide the loading message...eg
                            app.dv.modelLogin().hide();
                        }
                    }
                    catch (error) {
                        // There was an error attempting to open the private form, display the error...AM
                        app.dv.actionLibrary.executeShowMessage(null, null, null, (error && error.message) ? error.message : error, true, null, false, null);

                        //Hide the loading message...eg
                        app.dv.modelLogin().hide();
                    }
                }
                else {
                    setTimeout(() => {
                        //Hide the loading message...eg
                        app.dv.modelLogin().hide();
                    });
                }
            };

            /**
             * Check for and process any querystring for tihs app space in the window location string.
             * Any found parameters will be assigned to the API querystring object.
             */
            let handleQueryString = () => {
                //Use the ? to split the url, if it exists, the query string will be on the right (index 1)...EK
                let browserQueryString = decodeURI(window.location.href.split('?')[ 1 ]);

                if (browserQueryString != null) {
                    //We have a query string to work with...EK

                    if (/(.+)_token/.test(browserQueryString)) {
                        // Parse the query string out of the oauth state value and set it to the internal queryStringParams
                        let originalQS = decodeURIComponent(browserQueryString.split('&qs=')[1]);
                        api.environment.setQueryStringObject(originalQS || '');


                        // Rebuild the URL back to its original state before SSO was triggered (without reloading the page)
                        let paramString = '',
                            pathString = '';
                        for (let param in api.environment.queryStringParams) {
                            if (api.environment.queryStringParams.hasOwnProperty(param)) {
                                if (param === 'privateFormName') {
                                    // Add the private form name back to the URL
                                    pathString = `form/${api.environment.queryStringParams.privateFormName}`;
                                }
                                else if (param === 'adminAccess') {
                                    // Add "/admin" back to the URL
                                    pathString = `admin`;
                                }
                                else {
                                    paramString += `${paramString === '' ? '?' : '&'}${param}=${api.environment.queryStringParams[param]}`
                                }
                            }
                        }
                        history.pushState(null, document.title, window.location.origin + '/' + pathString + paramString);
                    }
                    else {
                        // Set the specified query strings into the internal queryStringParams
                        api.environment.setQueryStringObject(browserQueryString || '');
                    }
                }
            };

            // Check to see if the URL this app space was logged in under has a query string, if so process it.
            handleQueryString();

            if (window.location.pathname === '/admin') {
                // Use the designer access path
                doLogin();
            }
            else if (publicFormName || customLoginForm) {
                // Attempt to load the specified public form
                let args = publicFormName
                    ? {AccessName: publicFormName}
                    : customLoginForm;

                try {
                    const results = await app.dv.cache.session.getPublicForm(args);
                    if (results) {
                        // The specified public form is valid and the guest user is authenticated, display the public form.
                        await createWorkspace(false, false);

                        app.dv.actionLibrary.inlineExe(null, app.dv.actionLibrary.actionStores.dvCore.OpenView, {
                            viewId: results.ViewID,
                            mode: results.openMode != null ? results.openMode : app.dv.types.OPEN_MODES.NORMAL,
                            supressVisiblity: false
                        }, (openResult) => {
                            if (openResult && !openResult.success || (!openResult.continueExecution && openResult.actionMessage !== "")) {
                                // if there is a problem, show the returned message.
                                let message = (typeof openResult.actionMessage === "object") ? openResult.actionMessage.message : openResult.actionMessage;
                                app.dv.actionLibrary.executeShowMessage(null, null, null, message, true, null, false, app.dv.types.MessageType.Error, "Error during load");
                            }

                            // Login form is not shown, we need to add the classes to prevent bouncing on mobile manually
                            document.body.classList.add("workspace-added");
                            document.documentElement.classList.add("workspace-added");

                            //Hide the loading message...eg
                            app.dv.userWorkspace.baseElement.style.visibility = "visible";
                            c.isLoading(false);
                        });
                    } else {
                        doLogin();
                    }
                } catch (error) {
                    doLogin();

                    app.dv.modelLogin().setErrorMessage(`There was an error accessing form "${publicFormName || customLoginForm.UID}". ${(error && error.message) ? error.message : ""}.`, true);
                }
            }
            else if (authType) {
                // Attempt to login using the specified SSO provider
                let tokenKey = `${authType}_token`;
                app.dv.modelLogin().show();
                app.dv.modelLogin().showContent(false);
                app.dv.modelLogin().showLoading(true);

                app.dv.cache.session.authenticateUser({
                    UserLoginID: queryParams.username,
                    [tokenKey]: queryParams[tokenKey],
                    oid: queryParams.oid,
                }, true, true, (isAuthenticated) => {
                    if(isAuthenticated == null || isAuthenticated.isAuthenticated !== true) {
                        if (tools.get(app.dv.cache.session, "appContext.user.Definition.clientProperties.stayLoggedInSSOType") != null) {
                            app.dv.cache.session.appContext.user.Definition.clientProperties.stayLoggedInSSOType = null;
                        }
                        app.dv.modelLogin().show(app.dv.compLogin.types.afterFirstLogin, (isAuthenticated, msg) => {
                            if (isAuthenticated === true) {
                                createWorkspace();
                            } else {
                                app.dv.actionLibrary.executeShowMessage(null, () => {
                                    app.dv.clientExit();
                                }, null, (msg != null ? msg : "Exiting client."), null, null, false, null);
                            }
                        }, null, true);
                        app.dv.modelLogin().setErrorMessage(`${authType} sign-in failed. ${(isAuthenticated && isAuthenticated.message) ? isAuthenticated.message : ''}`, true);

                        // Reset the URL to strip off query parameters from the end (without reloading the page)
                        history.pushState('', document.title, window.location.origin + window.location.pathname + (queryParams.qs != null && queryParams.qs !== '' ? '?' + queryParams.qs : ''));
                        return;
                    }

                    createWorkspace(undefined, undefined, true);
                }, authType);
            }
            else if (!app.dv.cache.isAppContextLoaded) {
                // Show the normal login screen once the app context is loaded
                app.dv.cache.isAppContextLoadeddSub = doLogin;
            }
            else {
                // Show the normal login screen
                doLogin();
            }

            if (queryParams.error) {
                app.dv.modelLogin().setErrorMessage(decodeURIComponent(queryParams.error), true);
            }
        }
    }).catch(console.error);

    //#region Window/Workspace methods

    c.addNewView = async function (view) {
        // We received a valid private form, attempt to open it...AM
        const result = await app.dv.actionLibrary.inlineExe(null, app.dv.actionLibrary.actionStores.dvCore.OpenView, {
            viewId: view.ViewID,
            mode: view.Definition.AccessOpenMode != null ? view.Definition.AccessOpenMode : app.dv.types.OPEN_MODES.NORMAL,
            supressVisiblity: false
        });
        if (result && !result.success || (!result.continueExecution && result.actionMessage !== "")) {
            // if there is a problem, show the returned message.
            let message = (typeof result.actionMessage === "object") ? result.actionMessage.message : result.actionMessage;
            app.dv.actionLibrary.executeShowMessage(null, null, null, message, true, null, false, app.dv.types.MessageType.Error, "Unable to load specified Form.");
        }
        return result;
    };

    c.createWindow = function (view, width, height, callback, showWindow, showTab, showOnTop, icon, helpUrl, showFrame) {
        if (app.apiContext) {
            var wsSize = {width: 100, height: 100};

            // default to showing the window.
            if (showWindow == null) {
                showWindow = true;
            }
            if (width > wsSize.width) {
                width = wsSize.width;
            }
            if (height > wsSize.height) {
                height = wsSize.height;
            }
        }

        // create a new window for this view.
        let w = new app.windows.ViewWindow(view, width, height);
        w.setIcon(icon);
        w.setHelpUrl(helpUrl);
        app.dv.userWorkspace.windowManager.addWindow(w).then(() => {
            callback(w);
            return w;
        });
    };

    c.createDesignerWindow = function(uid, width, height, callback, title, description, icon, helpUrl, modal = true) {
        // create a new window for this view.
        let w = new app.windows.DesignerWindow(uid, width, height);
        w.setIcon(icon);
        w.setHelpUrl(helpUrl);
        w.titleTooltip(description);
        w.windowTitle = title;
        if (!modal) {
            w.setWindowType(app.baseControls.WINDOW_TYPES.NORMAL);
        }
        app.dv.userWorkspace.windowManager.addWindow(w).then(() => {
            callback(w);
            return w;
        });
    };

    c.createInputWindow = function(uid, idPrefix, width, height, callback, title, description, icon, helpUrl, modal) {
        // create a new window for this view.
        let w = new app.baseControls.BaseInputWindow(uid, width, height);
        w.setIcon(icon);
        w.setHelpUrl(helpUrl);
        w.titleTooltip(description);
        w.windowTitle = title;
        if (modal) {
            w.setWindowType(app.baseControls.WINDOW_TYPES.MODAL);
        }
        if (idPrefix) {
            w.baseElement.id = `${idPrefix}${uid}`;
        }
        app.dv.userWorkspace.windowManager.addWindow(w).then(() => {
            callback(w);
            return w;
        });
    };

    c.createModalWindow = function (view, width, height, callback, showWindow, showTab, showOnTop, icon, helpUrl, showFrame) {
        let w = app.dv.createNewViewWindow(view, width, height, icon, helpUrl, null);
        w.showMinimize(false);
        w.setWindowType(app.baseControls.WINDOW_TYPES.MODAL);
        app.dv.userWorkspace.windowManager.addWindow(w).then(() => {
            callback(w);
            return w;
        });
    };

    c.createUserMessagePrompt = function (msgType, msgPanel, title) {
        return new app.windows.PromptMessageWindow(undefined, undefined, undefined, msgType, msgPanel, title);
    };

    c.createUserInputPrompt = function (msgType, msgPanel, title, defaultText) {
        return new app.windows.PromptInputWindow(undefined, undefined, undefined, msgType, msgPanel, title, defaultText);
    };

    c.centerWindow = function (view) {
        return app.dv.userWorkspace.windowManager.centerWindow(view);
    };

    c.createNewViewWindow = function (view, width, height, icon = null, helpUrl = null, tooltip = null) {
        let win = new app.windows.ViewWindow(view, width, height);
        if (icon) win.setIcon(icon);
        if (helpUrl) win.setHelpUrl(helpUrl);
        if (tooltip) win.titleTooltip(tooltip);
        return win;
    };

    c.currentSize = function () {
        return app.apiContext
            ? {width: 100, height: 100}
            : {width: app.dv.userWorkspace.width, height: app.dv.userWorkspace.height};
    };

    //#endregion

    return c;
}

export default {viewModel: componentViewModel, template: clientTemplate};
